<template>
  <div class="home-page">
    <section class="hero">
      <div class="hero-inner">
        <div class="hero-left">
          <div class="video-card">
            <div
              class="video-thumb"
              role="button"
              tabindex="0"
              @click="openVideoModal"
              @keydown.enter="openVideoModal"
              @keydown.space.prevent="openVideoModal"
            >
            
              <video
                class="video-player"
                src="/videos/smilefile.mp4"
                controls
                playsinline
                preload="metadata"
              ></video>
            </div>
          <div class="video-meta">
              <p class="eyebrow">für Kunden der WaizmannTabelle</p>
              <h1>SmileFile Abrechnungsplan</h1>
          
              <p class="video-title">So schafft der Smile-File Abrechnungsplan Sicherheit in den ersten Jahren:</p>
              <div class="steps">
                <div class="step-item">
                  <span class="step-number">1</span>
                  <div>
                    <strong>Jahrgenaue Abrechnungsbeträge auf einen Blick</strong>
                    <p>
                      Sie sehen für jedes Versicherungsjahr separat, welcher Betrag maximal
                      abrechenbar ist – klar beziffert, nicht geschätzt.
                    </p>
                  </div>
                </div>
                <div class="step-item">
                  <span class="step-number">2</span>
                  <div>
                    <strong>Klare Limits statt Unsicherheit</strong>
                    <p>
                      Der Abrechnungsplan zeigt exakt, wie hoch das Erstattungslimit im 1., 2., 3.
                      und 4. Jahr ist und ab welchem Jahr das volle Erstattungspotenzial verfügbar
                      ist.
                    </p>
                  </div>
                </div>
                <div class="step-item">
                  <span class="step-number">3</span>
                  <div>
                    <strong>Behandlungen exakt am Budget ausrichten</strong>
                    <p>
                      Sie planen nicht mehr ins Blaue, sondern wissen vorab, welche Leistungen in
                      welchem Jahr in welcher Höhe erstattet werden.
                    </p>
                  </div>
                </div>
                <div class="step-item">
                  <span class="step-number">4</span>
                  <div>
                    <strong>Keine verschenkte Abrechnung mehr</strong>
                    <p>
                      Sie vermeiden, Leistungen zu früh abzurechnen, obwohl in einem späteren
                      Versicherungsjahr höhere Budgets verfügbar wären.
                    </p>
                  </div>
                </div>
                <div class="step-item">
                  <span class="step-number">5</span>
                  <div>
                    <strong>Abrechnungssicherheit vom ersten Tag an</strong>
                    <p>
                      Der SmileFile Abrechnungsplan gibt Sicherheit, welche Beträge Sie jetzt, im
                      nächsten Jahr und in den Folgejahren abrechnen können.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hero-right">
          <a
            class="waizmann-box"
            href="https://www.teamwaizmann.de"
            target="_blank"
            rel="noopener"
          >
            <div class="waizmann-box-mark">®</div>
            <div class="waizmann-box-title">WaizmannTabellen anfordern</div>
            <div class="waizmann-box-footer">
              <div class="waizmann-box-original">das Original</div>
              <div class="waizmann-box-since">seit 1955</div>
            </div>
          </a>
        </div>
      </div>
    </section>

    <v-dialog v-model="isVideoExpanded" max-width="720">
      <v-card class="video-modal">
        <div class="video-modal-body">
          <video
            class="video-player modal-player"
            src="/videos/smilefile.mp4"
            controls
            playsinline
            preload="metadata"
            autoplay
          ></video>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const isVideoExpanded = ref(false)

function openVideoModal () {
  isVideoExpanded.value = true
}
</script>

<style scoped>
.home-page {
  display: flex;
  flex-direction: column;
  gap: 48px;
  padding: 48px 0 64px;
}

.hero {
  background: #f8fafb;
  padding: 56px 0;
}

.hero-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 36px;
  align-items: start;
}

.hero-left {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.hero-right {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: min(260px, 100%);
  align-self: start;
  position: sticky;
  top: 120px;
}

.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.75rem;
  color: #1e88e5;
  font-weight: 600;
}

.video-meta h1 {
  font-size: clamp(1.8rem, 3vw, 2.2rem);
  margin: 6px 0 8px;
  color: #0f1f2f;
}

.video-meta .subtitle {
  font-size: 1.02rem;
  color: #495463;
  line-height: 1.6;
  margin: 0 0 6px;
}

.highlight {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid rgba(15, 31, 47, 0.08);
  margin-bottom: 20px;
}

.highlight strong {
  display: block;
  color: #0f1f2f;
  margin-bottom: 4px;
}

.highlight p {
  margin: 0;
  color: #495463;
}

.cta-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 16px;
}

.steps {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 10px;
}

.step-item {
  display: grid;
  grid-template-columns: 28px 1fr;
  gap: 12px;
  align-items: start;
}

.step-number {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  background: #f1f5f9;
  color: #0f1f2f;
  font-weight: 700;
  display: grid;
  place-items: center;
  font-size: 0.9rem;
}

.step-item strong {
  display: block;
  color: #0f1f2f;
  margin-bottom: 2px;
}

.step-item p {
  margin: 0;
  color: #495463;
  line-height: 1.5;
}

.video-card {
  background: #ffffff;
  color: #0f1f2f;
  border-radius: 4px;
  padding: 20px;
  box-shadow: none;
  border: 1px solid rgba(15, 31, 47, 0.1);
  margin-top: 0;
  display: grid;
  grid-template-columns: minmax(120px, 160px) 1fr;
  gap: 20px;
  align-items: start;
}

.video-thumb {
  background: #f1f5f9;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  aspect-ratio: 9 / 16;
  width: 100%;
  justify-content: center;
  border: 1px solid rgba(15, 31, 47, 0.08);
  overflow: hidden;
  cursor: pointer;
  position: relative;
}

.video-player {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  background: #000000;
}

.video-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 42px;
  aspect-ratio: 105 / 168;
  background: #3166A5;
  color: #ffffff;
  border-radius: 3px;
  font-size: 0.55rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  display: grid;
  place-items: center;
  z-index: 2;
}

.video-modal {
  background: #0f1f2f;
  border-radius: 6px;
}

.video-modal-body {
  padding: 0;
}

.modal-player {
  width: auto;
  height: auto;
  aspect-ratio: 9 / 16;
  background: #000000;
  max-height: 70vh;
  max-width: 100%;
  margin: 0 auto;
}

.video-meta {
  margin-top: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.video-title {
  font-weight: 600;
  margin-bottom: 6px;
}

.video-text {
  margin: 0;
  color: #495463;
}

.waizmann-box {
  background: #3166A5;
  color: #ffffff;
  border-radius: 4px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  aspect-ratio: 105 / 168;
  position: relative;
  text-decoration: none;
  width: min(260px, 100%);
  box-shadow: none;
}

.waizmann-box-title {
  font-size: 20px;
  font-weight: 800;
  line-height: 1.2;
}

.waizmann-box-mark {
  position: absolute;
  top: 6px;
  right: 8px;
  font-size: 12px;
  font-weight: 700;
  opacity: 0.9;
}

.waizmann-box-footer {
  position: absolute;
  right: 10px;
  bottom: 10px;
  text-align: right;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.waizmann-box-original {
  font-size: 18px;
  font-weight: 700;
}

.waizmann-box-since {
  font-size: 15px;
  opacity: 0.9;
}

.contact {
  padding: 0;
}

.contact-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
}

.contact h2 {
  margin: 0;
  color: #0f1f2f;
}

.contact p {
  margin: 0;
  color: #495463;
}

@media (max-width: 680px) {
  .hero {
    padding: 32px 0;
  }

  .hero-inner,
  .contact-inner {
    padding: 0 16px;
  }

  .hero-inner {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .hero-right {
    display: none;
  }

  .video-card {
    grid-template-columns: 1fr;
  }

  .video-thumb {
    max-width: 220px;
    margin: 0 auto;
  }

  .steps {
    gap: 10px;
  }

  .step-item {
    grid-template-columns: 24px 1fr;
  }

  .step-number {
    width: 24px;
    height: 24px;
    font-size: 0.8rem;
  }

  .video-badge {
    width: 36px;
    font-size: 0.5rem;
  }

  .modal-player {
    max-height: 80vh;
  }
}
</style>
